import BaseModel from "./BaseModel"

export default class Link extends BaseModel {
  rel: string
  href: string
}
